import React from 'react';
import PropTypes from 'prop-types';

const GlideConfigScript = ({ slideCount, ...rest }) => {
  // If there one or less slide there is no need for the carousel to be initialized
  if (slideCount <= 1) {
    return false;
  }

  return (
    <script
      data-glide
      dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
        __html: JSON.stringify({ slideCount, ...rest }),
      }}
      type="application/json"
    />
  );
};

GlideConfigScript.propTypes = {
  slideCount: PropTypes.number.isRequired,
  carouselId: PropTypes.string.isRequired,
};

export default GlideConfigScript;
